module.exports = __webpack_public_path__ + "img/IMG_9239.bf850a49.jpg";